<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelPromo"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="!isRequired"
    :preselectFirst="false"
    :loading="loading"
    :label="$t('Nome')"
    track-by="ID"
    :disabled="isDisabled || !idSite || loading"
    placeholder=""
    openDirection="below"
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {
      type: [String, Object, Number],
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    emptyLabel: {
      type: String,
      default: 'Selecione uma promoção'
    },
    includeAll: {
      type: Boolean,
      default: false
    },
    idSite: {
      type: [Number, String],
      default: null
    },
    type: {
      type: String,
      default: 'GIFT_VOUCHER'
    }
  },

  data() {
    return {
      selected: null,
      options: [],
      loading: false,
      pendingNameField: null,
      optionsLoaded: false
    };
  },

  methods: {
    onChange(e) {
      const uuid = e ? e.ID : null;
      this.$emit('input', uuid);
      this.$emit('selectChange', 'promoVinculada', uuid);
      if (uuid) {
        this.$emit('focus');
      }
    },
    labelPromo({ name, pattern }) {
      return `${name} - ${pattern}`;
    },
    setValue(value) {
      if (!value) {
        this.selected = null;
        return;
      }

      const compareId = typeof value === 'object' ? value.ID || value.id : value;

      if (!compareId) {
        this.selected = null;
        return;
      }

      const option = this.options.find((opt) => String(opt.ID) === String(compareId));

      if (option) {
        this.selected = option;
        return;
      }

      if (this.optionsLoaded) {
        this.fetchOptionById(compareId);
      } else {
        this.pendingNameField = compareId;
      }
    },
    fetchOptionById(id) {
      if (!this.idSite || !id) return;

      this.loading = true;

      this.$api
        .search('promo/campaign', { id_site: this.idSite, promoId: id })
        .then((res) => {
          const option = Array.isArray(res) ? res[0] : res?.data?.[0] || res;

          if (option?.ID) {
            if (!this.options.find((opt) => String(opt.ID) === String(option.ID))) {
              this.options.push(option);
            }
            this.selected = option;
          }
        })
        .catch((err) => {
          console.error('Erro ao buscar promoção específica:', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setOptions() {
      if (!this.idSite) {
        this.options = [];
        this.selected = null;
        this.optionsLoaded = false;
        return;
      }

      const params = {
        id_site: this.idSite,
        type: this.type
      };

      this.loading = true;
      this.optionsLoaded = false;

      this.$api
        .search('promo/campaign', params)
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ ID: null, name: this.$i18n.t(this.emptyLabel), pattern: '' }];
          }

          if (res) {
            if (Array.isArray(res)) {
              this.options = this.options.concat(res);
            } else if (res.data && Array.isArray(res.data)) {
              this.options = this.options.concat(res.data);
            }
          }

          this.optionsLoaded = true;

          this.$nextTick(() => {
            const value = this.pendingNameField ?? this.nameField;
            if (value) this.setValue(value);
            this.pendingNameField = null;
          });
        })
        .catch((err) => {
          console.error('Erro ao carregar promoções:', err);
          this.options = [];
          this.optionsLoaded = true;
          this.$util.formWarn({
            msgTitle: 'Erro ao Carregar Promoções',
            msgContent: err?.message || 'Entre em contato com o Administrador do Sistema.',
            type: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    if (this.idSite) {
      this.setOptions();
    }
  },
  watch: {
    nameField(value) {
      if (this.optionsLoaded) {
        this.setValue(value);
      } else {
        this.pendingNameField = value;
      }
    },
    idSite() {
      this.pendingNameField = this.nameField;
      this.setOptions();
    }
  }
};
</script>

<style lang="scss" scoped></style>
